import React from 'react'
import "../healthy_live/HealthyLive.css"
import { Col, Container, Row } from 'react-bootstrap'
const HealthyLive = () => {
  return (
    <>
    <section id="healthy_live">
      <Container>
        <Row className='healthy_live_inner'>
          <Col lg={5}>
            <div class="healthy_live_main">
              <h1>Fruits For Live Healthy</h1>
              <p>Donec sollicitudin molestie malesuada. Lorem ipsum dolor sit amet,consectetur adipiscing elit.</p>
              <a href="#"><button class="shop_now">shop now</button></a>
            </div>
          </Col>
        </Row>
      </Container>
   </section>
    </>
  )
}

export default HealthyLive